const { normalizeTranslatorLang } = require('./rules')

const TRANSLATOR_IGNORE_ATTR = 'data-page-translator-ignore'
const LANGUAGE_STORAGE_KEY = 'docbook_page_translate_lang'
const POSITION_STORAGE_PREFIX = 'docbook_page_translate_position_'
const TRANSLATOR_MEETING_READY_EVENT = 'page-translator-meeting-ready'

const DEFAULT_TRANSLATOR_OPTIONS = {
    batchSize: 50,
    maxItemChars: 1000,
    maxBatchChars: 8000,
    concurrency: 9,
    debounceTime: 400
}

const EXCLUDED_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE', 'NOSCRIPT']
const EXCLUDED_CLASS_NAMES = []

const ROUTE_WHITELIST = [
    'meetingHome',
    'meetingDetail',
    'expertTaskList',
    'expertsSchedule',
    'expertConfirmation'
]

const PATH_WHITELIST = [
    /^\/meetingHome$/,
    /^\/meetingDetail$/,
    /^\/expertTaskList$/,
    /^\/expertsSchedule$/,
    /^\/expertConfirmation$/
]

const EXPERT_TASK_ROUTE_NAMES = [
    'expertTaskList',
    'expertsSchedule',
    'expertConfirmation'
]

function getRouteKey(route) {
    if (!route) return 'default'
    return route.name || String(route.path || 'default').replace(/[^\w-]/g, '_')
}

function isRouteAllowed(route) {
    if (!route) return false
    if (route.name && ROUTE_WHITELIST.indexOf(route.name) > -1) return true
    const path = route.path || ''
    return PATH_WHITELIST.some(pattern => pattern.test(path))
}

function resolveMeetingId(route) {
    if (!route) return ''
    const query = route.query || {}
    return query.meeting_id || ''
}

function isExpertTaskRoute(route) {
    return !!(route && EXPERT_TASK_ROUTE_NAMES.indexOf(route.name) > -1)
}

function getExpertTaskId(route) {
    if (!route) return ''
    const query = route.query || {}
    const params = route.params || {}
    return params.id || query.id || ''
}

function notifyTranslatorMeetingReady(taskId, meetingId) {
    if (
        typeof window === 'undefined' ||
        typeof window.CustomEvent !== 'function' ||
        !taskId ||
        !meetingId
    ) return

    window.dispatchEvent(new window.CustomEvent(TRANSLATOR_MEETING_READY_EVENT, {
        detail: {
            taskId: String(taskId),
            meetingId: String(meetingId)
        }
    }))
}

function normalizeTranslateStatusResponse(response) {
    if (!response) return null
    return response.data && typeof response.data === 'object' ? response.data : response
}

function shouldSkipText(text) {
    return !String(text || '').trim()
}

function getStoredLanguage(storage) {
    if (!storage) return 'none'
    return normalizeTranslatorLang(storage.getItem(LANGUAGE_STORAGE_KEY))
}

function setStoredLanguage(storage, lang) {
    if (!storage) return
    storage.setItem(LANGUAGE_STORAGE_KEY, normalizeTranslatorLang(lang))
}

function getPositionStorageKey(route) {
    return POSITION_STORAGE_PREFIX + getRouteKey(route)
}

module.exports = {
    TRANSLATOR_IGNORE_ATTR,
    LANGUAGE_STORAGE_KEY,
    POSITION_STORAGE_PREFIX,
    TRANSLATOR_MEETING_READY_EVENT,
    DEFAULT_TRANSLATOR_OPTIONS,
    EXCLUDED_TAGS,
    EXCLUDED_CLASS_NAMES,
    ROUTE_WHITELIST,
    PATH_WHITELIST,
    EXPERT_TASK_ROUTE_NAMES,
    getRouteKey,
    isRouteAllowed,
    resolveMeetingId,
    isExpertTaskRoute,
    getExpertTaskId,
    notifyTranslatorMeetingReady,
    normalizeTranslateStatusResponse,
    shouldSkipText,
    getStoredLanguage,
    setStoredLanguage,
    getPositionStorageKey
}
